import React from 'react';
import PropTypes from 'prop-types';

import NameIcon from 'components/NameIcon';
import { getColorByTextValue } from 'utils';

import styles from './styles.module.scss';

function AvatarView({ className, text, photo, onClick }) {
  const color = getColorByTextValue(text);
  const style = color
    ? { backgroundColor: color, backgroundImage: 'none' }
    : {};

  return (
    <div className={className} onClick={onClick} >
      {photo ? (
        <img
          className={styles.userImg}
          src={`data:image/png;base64,${photo}`}
          alt={`avatar`}
        />
      ) : (
        <NameIcon
          style={style}
          text={text}
        />
      )}
    </div>
  );
}

AvatarView.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  photo: PropTypes.string,
};

export default AvatarView;
